var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowLeft({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.1076 32.6725L15.5801 20.96C15.3273 20.7044 15.1855 20.3595 15.1855 20C15.1855 19.6405 15.3273 19.2955 15.5801 19.04L27.1051 7.32749C27.3578 7.07035 27.4994 6.72426 27.4994 6.36374C27.4994 6.00322 27.3578 5.65713 27.1051 5.39999C26.9816 5.27337 26.8341 5.17274 26.6712 5.10403C26.5082 5.03532 26.3332 4.99992 26.1563 4.99992C25.9795 4.99992 25.8045 5.03532 25.6415 5.10403C25.4786 5.17274 25.331 5.27337 25.2076 5.39999L13.6826 17.11C12.9253 17.8813 12.501 18.919 12.501 20C12.501 21.0809 12.9253 22.1187 13.6826 22.89L25.2076 34.6C25.3311 34.727 25.4788 34.828 25.6419 34.8969C25.8051 34.9658 25.9805 35.0013 26.1576 35.0013C26.3347 35.0013 26.5101 34.9658 26.6732 34.8969C26.8364 34.828 26.9841 34.727 27.1076 34.6C27.3603 34.3429 27.5019 33.9968 27.5019 33.6362C27.5019 33.2757 27.3603 32.9296 27.1076 32.6725Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeft);
export default __webpack_public_path__ + "static/media/ArrowLeft.73510a6cfdb7e54fce2d929c01f992d7.svg";
export { ForwardRef as ReactComponent };